import { useEffect, useState } from "react";
import SwitchBox from "./SwitchBox";
import SwitchButton from "./SwitchButton";
import BankCard from "./BankCard";
import axios from "../../helpers/axios";
import { Button, ButtonBase, Pagination } from "@mui/material";
import { Close } from "@mui/icons-material";
import SortBy from "./SortBy";
import LoaderComp from "../../components/LoaderComp";
import PageLoader from "../../components/PageLoader";
import { useDispatch, useSelector } from "react-redux";
import LoanProductsService from "../../services/loanproducts";
import ProductModal from "./components/ProductModal";
import { ConfirmationPopup } from "../../components";
import { useToast } from "@chakra-ui/react";
import ViewBonusPopup from "./ViewBonusPopup";
import dayjs from "dayjs";
import { setFilters } from "../../redux/slice/filterSlice";
import { useLocation } from "react-router-dom";

const LoanProduct = () => {
  const location = useLocation();
  const pagePermission = location.state;

  const dispatch = useDispatch();
  const [anchorEls, setAnchorEls] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dynamicParam, setDynamicParam] = useState({});
  const [featureModal, setFeatureModal] = useState({
    show: false,
    id: null,
    status: null,
  });
  const [inactiveModal, setInactiveModal] = useState({
    show: false,
    id: null,
    status: 0,
  });
  const [deleteModal, setDeleteModal] = useState({
    show: false,
    id: null,
    status: null,
  });
  const toast = useToast();
  const [modalType, setModalType] = useState(null);
  const [product, setProduct] = useState(null);
  const [tabIdx, setTabIdx] = useState(0);
  const [searchKeyWord, setSearchKeyWord] = useState("");
  const [loading, setLoading] = useState(false);
  const settingsData = useSelector((state) => state.settings);
  const filters = useSelector((state) => state.filters);
  const [mobfilterBar, setmobfilterBar] = useState(false);
  const [switchButton, setSwitchButton] = useState(true);
  const [bonusPopUp, setbonusPopUp] = useState(false);
  const [allAgentData, setallAgentData] = useState(null);

  const [loanProducts, setLoanProducts] = useState(null);
  const [loanCounts, setLoanCounts] = useState(null);
  const [productPages, setProductPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [pageSize, setPageSize] = useState(24);

  const [expandedRemarksIndex, setExpandedRemarksIndex] = useState(null);

  let DefaultFilters = {
    vehicle: settingsData.vehicles[0].id,
    category: settingsData.categories[0].id,
    loanType: settingsData.categories[0].types[0].id,
    scheme: settingsData.categories[0].types[0].schemes[0].id,
    motorType: settingsData.productMotorTypes[0].id,
    usage: settingsData.productUsages[0].id,
    approvalTime: settingsData.approvalTimes[0].id,
    ltv: settingsData.ltvs[0].id,
    bonus: "all",
    toggleSwitch: "lt",
    status: 1,
    index: "0",
    keyword: "", // search
    //productType: "", // top filter
    sortKey: "name", // name
    sortOrder: "asc",
    collect_first_installment: "",
  };
  const [applyFilters, setApplyFilters] = useState(
    Object.keys(filters)?.length > 0
      ? { ...DefaultFilters, ...filters }
      : DefaultFilters
  );
  const [settingsIndex, setSettingsIndex] = useState(
    Object.keys(filters).length > 0 && filters?.settingIndex !== undefined
      ? filters?.settingIndex
      : {
        veh: 0,
        cat: 0,
        typ: 0,
        schm: 0,
      }
  );
  const handleAgentBonusPop = (agent, bonus) => {
    const popData = {
      ...agent,
      allAgent: bonus,
    };
    setallAgentData(popData);
    setbonusPopUp(true);
  };

  const settingsHandle = (idx, title, tabId) => {
    //console.log("title", idx, title, tabId);
    setCurrentPage(1);
    setLoanProducts([]);
    switch (title) {
      case "vehicle":
        console.log("settings vehicle", settingsData);
        console.log("vehicle type", settingsData.vehicles[idx].name);
        console.log("IDX veh", idx)

        setSettingsIndex({ ...settingsIndex, veh: idx, typ: 0 });
        setApplyFilters({
          ...applyFilters,
          vehicle: settingsData.vehicles[idx].id,
        });
        dispatch(
          setFilters({
            ...applyFilters,
            vehicle: settingsData.vehicles[idx].id,
          })
        );
        break;
      case "category":
        console.log(" CAT==", settingsData.categories[idx].id)
        console.log("loan type==", settingsData.categories[idx].types[0].id)

        setSettingsIndex({ ...settingsIndex, cat: idx, typ: 0 });
        setApplyFilters({
          ...applyFilters,
          category: settingsData.categories[idx].id,
          loanType: settingsData.categories[idx].types[0].id,
          scheme: settingsData.categories[idx].types[0].schemes[0].id,
          settingIndex: { ...settingsIndex, cat: idx, typ: 0 },
        });
        dispatch(
          setFilters({
            ...applyFilters,
            category: settingsData.categories[idx].id,
            loanType: settingsData.categories[idx].types[0].id,
            scheme: settingsData.categories[idx].types[0].schemes[0].id,
            settingIndex: { ...settingsIndex, cat: idx, typ: 0 },
          })
        );
        break;
      case "type":
        setSettingsIndex({ ...settingsIndex, typ: idx, schm: 0 });
        setApplyFilters({
          ...applyFilters,
          loanType: tabId,
          scheme:
            settingsData.categories[settingsIndex.cat].types[idx].schemes[0].id,
          settingIndex: { ...settingsIndex, typ: idx, schm: 0 },
        });
        dispatch(
          setFilters({
            ...applyFilters,
            loanType: tabId,
            scheme:
              settingsData.categories[settingsIndex.cat].types[idx].schemes[0]
                .id,
            settingIndex: { ...settingsIndex, typ: idx, schm: 0 },
          })
        );
        break;
      case "scheme":
        setSettingsIndex({ ...settingsIndex, schm: idx });
        setApplyFilters({
          ...applyFilters,
          loanType:
            settingsData.categories[settingsIndex.cat].types[settingsIndex.typ]
              .id,
          scheme: tabId,
          settingIndex: { ...settingsIndex, schm: idx },
        });
        dispatch(
          setFilters({
            ...applyFilters,
            loanType:
              settingsData.categories[settingsIndex.cat].types[
                settingsIndex.typ
              ].id,
            scheme: tabId,
            settingIndex: { ...settingsIndex, schm: idx },
          })
        );
        break;
      case "motor":
        setApplyFilters({
          ...applyFilters,
          motorType: tabId,
        });
        dispatch(
          setFilters({
            ...applyFilters,
            motorType: tabId,
          })
        );
        break;
      case "usage":
        setApplyFilters({
          ...applyFilters,
          usage: tabId,
        });
        dispatch(
          setFilters({
            ...applyFilters,
            usage: tabId,
          })
        );
        break;
      case "approval time":
        setApplyFilters({
          ...applyFilters,
          approvalTime: tabId,
        });
        dispatch(
          setFilters({
            ...applyFilters,
            approvalTime: tabId,
          })
        );
        break;
      case "collect first installment?":
        setApplyFilters({
          ...applyFilters,
          collect_first_installment: tabId,
        });
        dispatch(
          setFilters({
            ...applyFilters,
            collect_first_installment: tabId,
          })
        );
        break;
      case "loan to value":
        setApplyFilters({
          ...applyFilters,
          ltv: tabId,
        });
        dispatch(
          setFilters({
            ...applyFilters,
            ltv: tabId,
          })
        );
        break;
      case "bonus":
        setApplyFilters({
          ...applyFilters,
          bonus: tabId,
        });
        dispatch(
          setFilters({
            ...applyFilters,
            bonus: tabId,
          })
        );
        break;
      default:
        break;
    }
  };
  const getLoanProduct = async (page) => {
    setLoading(true);
    const { data } = await axios.post(
      `/admin/loan/product/list/${pageSize}/${page}`,
      {
        ...applyFilters,
        bonus: applyFilters?.bonus === "all" ? "" : applyFilters?.bonus,
      }
    );

    setLoading(false);
    let totalProdCount = data?.total;
    let pageCount = Math.ceil(totalProdCount / 10);
    setTotalData(totalProdCount);
    setProductPages(pageCount);
    setLoanCounts(data?.counts);
    setLoanProducts(data?.data);
  };

  const handleOpenMenu = (index, event) => {
    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = event.currentTarget;
    setAnchorEls(newAnchorEls);
    setMenuOpen(true);
  };
  const handleCloseMenu = (act) => {
    setAnchorEls(Array(loanProducts.length).fill(null));
    setMenuOpen(false);
  };
  const handlePagination = (e, val) => {
    setCurrentPage(val);
    getLoanProduct(val);
  };

  const handleSortBy = (val) => {
    setCurrentPage(1);
    setLoanProducts([]);
    switch (val) {
      // case "Recent":
      //   setApplyFilters({
      //     ...applyFilters,
      //     sortKey: "created_at",
      //     sortOrder: "desc",
      //   });
      //   dispatch(
      //     setFilters({
      //       ...applyFilters,
      //       sortKey: "created_at",
      //       sortOrder: "desc",
      //     })
      //   );
      //   break;
      case "Featured":
        setApplyFilters({
          ...applyFilters,
          sortKey: "featured",
          sortOrder: "desc",
        });
        dispatch(
          setFilters({
            ...applyFilters,
            sortKey: "featured",
            sortOrder: "desc",
          })
        );
        break;
      case "High to Low":
        setApplyFilters({
          ...applyFilters,
          sortKey: "interest",
          sortOrder: "desc",
        });
        dispatch(
          setFilters({
            ...applyFilters,
            sortKey: "interest",
            sortOrder: "desc",
          })
        );
        break;
      case "Low to High":
        setApplyFilters({
          ...applyFilters,
          sortKey: "interest",
          sortOrder: "asc",
        });
        dispatch(
          setFilters({
            ...applyFilters,
            sortKey: "interest",
            sortOrder: "asc",
          })
        );
        break;
      case "A to Z":
        setApplyFilters({
          ...applyFilters,
          sortKey: "name",
          sortOrder: "asc"
        });
        dispatch(
          setFilters({
            ...applyFilters,
            sortKey: "name",
            sortOrder: "asc",
          })
        );
        break;
      case "Z to A":
        setApplyFilters({
          ...applyFilters,
          sortKey: "name",
          sortOrder: "desc",
        });
        dispatch(
          setFilters({
            ...applyFilters,
            sortKey: "name",
            sortOrder: "desc",
          })
        );
        break;
      default:
        break;
    }
  };


  useEffect(() => {
    if (loanCounts?.topFilterCounts?.length > 0) {
      if (Object.keys(dynamicParam).length < 1) {
        delete applyFilters[filters.topFilterParameter];
      }
    }
  }, [loanCounts, filters, dynamicParam]);

  const handleTopFilters = (idx, tabId, tab) => {
    setCurrentPage(1);
    setLoanProducts([]);
    delete applyFilters[dynamicParam.parameter];
    setDynamicParam(tab);
    setTabIdx(idx);
    dispatch(
      setFilters({
        ...applyFilters,
        index: idx,
        [tab.parameter]: tab.value,
        topFilterParameter: tab.parameter,
      })
    );
  };

  useEffect(() => {
    if (Object.keys(dynamicParam).length > 0) {
      delete applyFilters[dynamicParam.parameter];
      applyFilters[dynamicParam.parameter] = dynamicParam.value;
      setApplyFilters({ ...applyFilters, index: tabIdx });
    }
  }, [dynamicParam]);

  const handleSwitchButton = () => {
    setCurrentPage(1);
    setLoanProducts([]);
    setSwitchButton(!switchButton);
    setApplyFilters({
      ...applyFilters,
      toggleSwitch: switchButton ? "ht" : "lt",
    });
    dispatch(
      setFilters({
        ...applyFilters,
        toggleSwitch: switchButton ? "ht" : "lt",
      })
    );
  };
  useEffect(() => {
    setAnchorEls(Array(loanProducts?.length).fill(null));
  }, [loanProducts]);

  const handleModalClose = () => {
    if (modalType == "edit" || modalType == "new") {
      getLoanProduct(1);
    }
    setModalType(null);
  };
  const handleSearch = (e) => {
    setCurrentPage(1);
    setLoanProducts([]);
    setSearchKeyWord(e.target.value);
    setApplyFilters({ ...applyFilters, keyword: e.target.value });
    dispatch(
      setFilters({
        ...applyFilters,
        keyword: e.target.value,
      })
    );
  };
  useEffect(() => {
    if (applyFilters?.keyword !== null && applyFilters?.keyword !== undefined) {
      setSearchKeyWord(applyFilters?.keyword);
    }
  }, [applyFilters]);

  const confirmFeatured = async (id, status) => {
    try {
      let res = await axios.put(
        `/admin/loan/product/featured/update/${id}/${status === 1 ? 0 : 1}`,
        {}
      );
      if (res.data.resp_code) {
        await getLoanProduct(1);
        setFeatureModal((data) => ({
          ...data,
          id: null,
          status: null,
          show: false,
        }));
      } else throw { response: "Invalid response" };
    } catch (error) {
      alert(error.response.data.errors);
    }
    // let updatedList = loanProducts?.map((item) => {
    //   if (item.id == id) {
    //     return { ...item, featured: !status }; //gets everything that was already in item, and updates "done"
    //   }
    //   return item; // else return unmodified item
    // });
    // loanProducts(updatedList);
    // setFeatureModal((data) => ({
    //   ...data,
    //   show: false,
    //   id: null,
    //   status: false,
    // }));
  };
  const confirmInactive = async (id, status) => {
    try {
      let res = await axios.put(
        `/admin/loan/product/status/update/${id}/${status === 1 ? 0 : 1}`,
        {}
      );
      if (res.data.resp_code) {
        toast({
          title: "Success",
          description: res.data.message,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        await getLoanProduct(1);
        setInactiveModal((data) => ({
          ...data,
          id: null,
          status: null,
          show: false,
        }));
      } else throw { response: "Invalid response" };
    } catch (error) {
      alert(error.response.data.errors);
    }
  };

  const confirmDelete = async (id) => {
    const delted = await LoanProductsService.deleteLoanProduct({ id });
    toast({
      title: "Success",
      description: delted.message,
      status: "success",
      duration: 3000,
      isClosable: true,
    });
    await getLoanProduct(1);

    setDeleteModal((data) => ({
      ...data,
      show: false,
      id: null,
      status: false,
    }));
    return;
  };

  const onFeatureClick = async (id, status) => {
    setFeatureModal((data) => ({
      ...data,
      id: id,
      status: status,
      show: true,
    }));
    return;
  };
  const onInactiveClick = async (id, status) => {
    console.log(id, status);
    setInactiveModal((data) => ({
      ...data,
      id: id,
      status: status,
      show: true,
    }));
    return;
  };

  const onDeleteClick = async (id) => {
    console.log(id);
    setDeleteModal((data) => ({ ...data, id: id, show: true }));
  };
  const onEditClick = async (data) => {
    setProduct(data);
    setTimeout(() => {
      setModalType("edit");
    }, 500);
  };

  useEffect(() => {
    getLoanProduct(1);
  }, [applyFilters, filters]);

  const handleScroll = () => {
    if (
      Math.round(window.innerHeight) +
      Math.round(document.documentElement.scrollTop) !==
      Math.round(document.documentElement.offsetHeight)
    ) {
      if (
        document.documentElement.offsetHeight -
        (window.innerHeight +
          Math.round(document.documentElement.scrollTop)) <=
        1
      ) {
        if (loanProducts?.length < totalData && !loading) {
          getLoanProduct(currentPage + 1, "scroll");
          setCurrentPage(currentPage + 1);
        }
      } else {
        return;
      }
    } else {
      //console.log("called");
      if (loanProducts?.length < totalData && !loading) {
        getLoanProduct(currentPage + 1, "scroll");
        setCurrentPage(currentPage + 1);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading]);

  return (
    <div className="main_content flex-[1] bg-[#F5F5F5] w-[100%] min-h-screen">
      {bonusPopUp && (
        <ViewBonusPopup
          bonusPopUp={bonusPopUp}
          bonusData={allAgentData}
          closeBonusPop={() => setbonusPopUp(false)}
        />
      )}
      {/* {!loanProducts && <PageLoader />} */}
      {modalType ? (
        modalType == "new" ? (
          <ProductModal
            active={true}
            activeFilters={applyFilters}
            settingsIndex={settingsIndex}
            closePopUp={handleModalClose}
            pagePermission={pagePermission}
          />
        ) : (
          <ProductModal
            active={true}
            id={product.id}
            activeFilters={applyFilters}
            closePopUp={handleModalClose}
            pagePermission={pagePermission}
          />
        )
      ) : null}
      <div className="bg-white">
        <div className="flex pt-[20px] gap-y-2 justify-between flex-wrap items-center px-[24px]">
          <div className="whitespace-nowrap font-[700] text-[20px]">
            Manage Loan Product
          </div>
          <div className="flex max-[600px]:w-full items-center justify-between">
            <div className="relative w-[250px] max-w-[100%] max-[700px]:w-[100%]">
              <div className="absolute h-[100%] top-[0] left-[0] flex items-center max-[600px]:left-[10px] max-[600px]:top-[-2px]">
                <img
                  src="/images/search.svg"
                  alt="search"
                  className="pt-[3px]"
                />
              </div>
              <input
                type="search"
                placeholder="Search Product..."
                className="pl-[25px] outline-none text-[13px]  max-[600px]:border max-[600px]:border-gray-200 max-[600px]:p-[8px_20px_8px_33px] max-[600px]:rounded-[5px] max-[600px]:w-[calc(100%-50px)]"
                value={searchKeyWord}
                onChange={handleSearch}
              />
            </div>
            <div className="flex items-center">
              <div
                className="h-[36px] w-[50px] bg-[#0F172A] hidden max-[600px]:inline-flex items-center justify-center rounded-[5px] mx-[5px] relative "
                onClick={() => setmobfilterBar(!mobfilterBar)}
              >
                <img
                  src="/images/filter_icon.png"
                  alt="filter"
                  className="max-w-[100%] h-auto"
                  width="14"
                  height="14"
                />
              </div>
              {pagePermission?.create_permission == 1 && (
                <Button
                  type="button"
                  className="sav_btn bonus_btn"
                  onClick={() => setModalType("new")}
                >
                  <img
                    src="/images/add-circle-wh.svg"
                    alt="add"
                    className="hidden h-[20px] max-[700px]:block"
                  />
                  <span className="max-[700px]:hidden whitespace-nowrap">
                    Create Loan Product
                  </span>
                </Button>
              )}
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between mt-[12px] border-b-2 border-[#EAEAEA] px-[24px] max-[768px]:gap-[20px] max-[768px]:pr-[3px]">
          <div className="tab_Sec_box">
            <div className="tab_Sec flex">
              {loanCounts &&
                loanCounts.topFilterCounts.map((tab, idx) => {
                  return (
                    <ButtonBase className="hover:scale-100" key={idx}>
                      <div
                        className={`tab_menu ${applyFilters?.index === idx && "active"
                          }`}
                        onClick={() => handleTopFilters(idx, tab.value, tab)}
                      >
                        {tab.label} ({tab.count})
                      </div>
                    </ButtonBase>
                  );
                })}
            </div>
          </div>
          <SortBy handleSortBy={handleSortBy} value={applyFilters} />
        </div>
        <div
          className={`backDrop ${!mobfilterBar && "hidden"}`}
          onClick={() => setmobfilterBar(false)}
        ></div>
        <div
          className={`switch_box_sec p-[10px_10px_5px_30px] min-[601px]:relative min-[601px]:pr-[140px] border-b-2 border-[#EAEAEA] ${mobfilterBar && "active"
            }`}
        >
          <div
            className="text-end mb-[15px] hidden max-[600px]:block"
            onClick={() => setmobfilterBar(false)}
          >
            <Close />
          </div>
          {settingsData && (
            <>
              <SwitchBox
                title="Vehicle"
                tabs={settingsData.vehicles}
                settingsHandle={settingsHandle}
                value={applyFilters?.vehicle}
              />
              <SwitchBox
                title="Type"
                tabs={settingsData.categories}
                settingsHandle={settingsHandle}
                value={applyFilters?.category}
              />
              <SwitchBox
                title="Category"
                tabs={settingsData.categories[settingsIndex.cat].types}
                settingsHandle={settingsHandle}
                value={applyFilters?.loanType}
              />
              <SwitchBox
                title="Motor"
                tabs={settingsData.productMotorTypes}
                settingsHandle={settingsHandle}
                value={applyFilters?.motorType}
              />
              <SwitchBox
                title="Usage"
                tabs={settingsData.productUsages}
                settingsHandle={settingsHandle}
                value={applyFilters?.usage}
              />
              <SwitchBox
                title="Scheme"
                tabs={
                  settingsData.categories[settingsIndex.cat].types[
                    settingsIndex.typ
                  ].schemes.map((scheme) => ({
                    ...scheme,
                    disabled:
                      settingsData.vehicles[settingsIndex.veh]?.name === 'Commercial' &&
                      scheme.name === 'Balloon',
                  }))
                }
                settingsHandle={settingsHandle}
                value={applyFilters?.scheme}
              />
              <br />
              <SwitchBox
                title="Approval Time"
                tabs={settingsData.approvalTimes}
                info="info"
                settingsHandle={settingsHandle}
                value={applyFilters?.approvalTime}
              />
              {/* {console.log("LTvvvvvV", settingsData.ltvs, applyFilters?.ltv)} */}
              <SwitchBox
                title="Loan to Value"
                tabs={settingsData.ltvs}
                info="info"
                settingsHandle={settingsHandle}
                value={applyFilters?.ltv}
              />
              <SwitchBox
                title="Bonus"
                tabs={[
                  { name: "All", id: "all" },
                  { name: "Yes", id: "1" },
                  { name: "No", id: "0" },
                ]}
                info="info"
                settingsHandle={settingsHandle}
                value={applyFilters?.bonus}
              />
              <SwitchBox
                title="Collect First Installment?"
                tabs={[{ name: "All", id: "" }].concat(
                  settingsData.collect_first_installment_options?.map((it) => {
                    return {
                      ...it,
                      id: it.value,
                    };
                  })
                )}
                info="info"
                settingsHandle={settingsHandle}
                value={applyFilters.collect_first_installment}
              />
              <SwitchButton
                labelLeft={"LT"}
                labelRight={"HT"}
                right={applyFilters?.toggleSwitch === "ht" ? true : false}
                handleSwitchButton={handleSwitchButton}
              />
            </>
          )}
        </div>
      </div>
      <div className="p-[50px_25px] max-[700px]:p-[20px_12px]">
        {/* <div className="flex flex-wrap gap-[35px_20px]"> */}
        <div className="flex flex-wrap justify-start">
          {loading ? (
            <LoaderComp />
          ) : (
            <>
              {loanProducts && (
                <>
                  {loanProducts.length > 0 ? (
                    loanProducts.map((item, index) => {
                      const interestRates = item.interests.map((interest) =>
                        parseFloat(interest.interest)
                      );
                      const lowestInterestIndex = interestRates.indexOf(
                        Math.min(...interestRates)
                      );
                      const highestInterestIndex = interestRates.indexOf(
                        Math.max(...interestRates)
                      );
                      return (
                        <BankCard
                          anchorEl={anchorEls[index]}
                          menuOpen={menuOpen && anchorEls[index] !== null}
                          handleOpenMenu={handleOpenMenu}
                          handleCloseMenu={handleCloseMenu}
                          index={index}
                          activeTab={dynamicParam}
                          product={item}
                          key={item.id}
                          interestToggle={applyFilters.toggleSwitch}
                          onFeatureClick={onFeatureClick}
                          onDeleteClick={() => onDeleteClick(item.id)}
                          onInactiveClick={() =>
                            onInactiveClick(item.id, item.status)
                          }
                          allAgentBonus={handleAgentBonusPop}
                          onEditClick={onEditClick}
                          interestSort={
                            switchButton
                              ? lowestInterestIndex
                              : highestInterestIndex
                          }
                          pagePermission={pagePermission}
                          expandedRemarksIndex={expandedRemarksIndex}
                          setExpandedRemarksIndex={setExpandedRemarksIndex}
                        />
                      );
                    })
                  ) : (
                    <h2 className="font-[700] text-2xl text-center w-full">
                      No Products
                    </h2>
                  )}
                </>
              )}
            </>
          )}
        </div>
        {!loading && (
          <>
            {productPages > 1 && (
              <div className="flex flex-col items-center mt-[35px] relative z-0">
                <Pagination
                  count={productPages}
                  page={currentPage}
                  onChange={handlePagination}
                  variant="outlined"
                  color="primary"
                />
              </div>
            )}
          </>
        )}
      </div>

      {featureModal.show ? (
        <ConfirmationPopup
          type={"feature"}
          setActiveData={setFeatureModal}
          activeData={featureModal}
          onConfirm={confirmFeatured}
        />
      ) : null}
      {inactiveModal.show ? (
        <ConfirmationPopup
          type={"inactive"}
          setActiveData={setInactiveModal}
          activeData={inactiveModal}
          onConfirm={confirmInactive}
        />
      ) : null}
      {deleteModal.show ? (
        <ConfirmationPopup
          type={"delete"}
          setActiveData={setDeleteModal}
          activeData={deleteModal}
          onConfirm={confirmDelete}
        />
      ) : null}
      {featureModal.show ? (
        <ConfirmationPopup
          type={"feature"}
          setActiveData={setFeatureModal}
          activeData={featureModal}
          onConfirm={confirmFeatured}
        />
      ) : null}
    </div>
  );
};

export default LoanProduct;
